module.exports = __webpack_public_path__ + "static/media/Open-Sans-regular.4124088f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Open-Sans-regular/Open-Sans-regular.woff2
// module id = 414
// module chunks = 0